import React, { useState, useContext, useEffect, useRef } from 'react';
import { View, StyleSheet, Text, Dimensions, ScrollView, Platform, useColorScheme } from "react-native";
import AsyncStorage from '@react-native-async-storage/async-storage';
import { showMessage } from "react-native-flash-message";
import { useTheme } from '@react-navigation/native';
import { ActivityIndicator } from 'react-native-paper';
import CustomInput from '../../../components/CustomInput';
import CustomButton from '../../../components/CustomButton';
import CustomText from '../../../components/CustomText/CustomText';

// Sign in hook with error handling async wait 
import { useSignin } from '../../../hooks/useSignIn';

// Screen and window dimensions 
const window = Dimensions.get("window");
const screen = Dimensions.get("screen");

// * Handle SVG logo 
import SvgXml from 'react-native-svg';

// * Logo Path
import { Light, Dark } from '../../../img/logos';

// * Language 
import { useTranslation } from 'react-i18next';


const SignUpScreen = ({ navigation, route }) => {

  const { t } = useTranslation();

  let colorScheme = useColorScheme();
  colorScheme = 'light'
  const { colors } = useTheme();

  const styles = makeStyles(colors, colorScheme)

  const emailRef = useRef(null);
  const usernameRef = useRef(null);
  const passwordRef = useRef(null);
  const submitClickedRef = useRef(null);

  const [email, setEmail] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [submitClicked, setSubmitClicked] = useState(false);
  const [dimensions, setDimensions] = useState({ window, screen });

  // validation errors
  const [emailError, setEmailError] = useState("");
  const [usernameError, setUsernameError] = useState("");
  const [passwordError, setPasswordError] = useState("");

  const { singUp, signin, isLoading } = useSignin();

  useEffect(() => {
    usernameRef.current = username;
    if (submitClickedRef.current) {
      validateUsername();
    };
  }, [username]);

  useEffect(() => {
    emailRef.current = email;
    if (submitClickedRef.current) {
      validateEmail();
    };
  }, [email]);

  useEffect(() => {
    passwordRef.current = password;
    if (submitClickedRef.current) {
      validatePassword();
    };
  }, [password]);

  useEffect(() => {
    submitClickedRef.current = submitClicked;
  }, [submitClicked]);

  const onSignInPressed = async (e) => {
    e.preventDefault();
    setSubmitClicked(true);
    if (!validateUsername() | !validatePassword() | !validateEmail()) {
      outputErrorMessage(t('common:errAllFields'));
    } else {
      if (emailRef.current.includes('deloitte')) {
        AsyncStorage.removeItem("client_api");
        AsyncStorage.setItem(
          "client_api",
          JSON.stringify({
            clientApi: 'https://test.oasys.com.cy/test/',
          }));
        signin(usernameRef.current, passwordRef.current, 'https://test.oasys.com.cy/test/');

      }
      else {
        await singUp(usernameRef.current, passwordRef.current, emailRef.current,);
      }
    };
  };

  const outputErrorMessage = (message) => {
    showMessage({
      message: message,
      type: "danger",
      duration: 3000,
    });
  }

  // TODO 
  // const onForgotPasswordPressed = () => {
  //   console.warn("ForgotPassword");
  // }

  const validateEmail = () => {
    if (emailRef.current === "") {
      setEmailError(t('common:errRequired'));
      return false;
    } else {
      setEmailError("");
      return true;
    };
  };

  const validateUsername = () => {
    if (usernameRef.current === "") {
      setUsernameError(t('common:errRequired'));
      return false;
    } else {
      setUsernameError("");
      return true;
    };
  };

  const validatePassword = () => {
    if (passwordRef.current === "") {
      setPasswordError(t('common:errRequired'));
      return false;
    } else {
      setPasswordError("");
      return true;
    };
  };

  return (
    <ScrollView
      style={styles.areaview}
      showsVerticalScrollIndicator={false}
      contentContainerStyle={{ flexGrow: 1, justifyContent: 'center', alignItems: 'center' }}>
      <View style={styles.root}>
        {colorScheme === 'light' ?
          <Light /> :
          <Dark />
        }

        <CustomInput
          placeholder={t('common:email')}
          value={email}
          setValue={setEmail}
          type="LOGIN"
          autoCapitalize='none'
        />
        <CustomText style={styles.error}>{usernameError}</CustomText>

        <CustomInput
          placeholder={t('common:username')}
          value={username}
          setValue={setUsername}
          type="LOGIN"
          autoCapitalize='none'
        />
        <CustomText style={styles.error}>{usernameError}</CustomText>
        <CustomInput
          placeholder={t('common:password')}
          value={password}
          setValue={setPassword}
          type="LOGIN"
          autoCapitalize='none'
          // No need to send property it default to true anw  ({true})
          secureTextEntry
        />
        <CustomText style={styles.error}>{passwordError}</CustomText>
        <CustomButton
          text={t('common:signIn')}
          // disable while processing one request 
          disabled={isLoading}
          onPress={onSignInPressed}
          type="LOGIN"
          isGradient={true}
        />

        {/* not needed for now */}
        {/* <CustomText style={{ marginTop: '5%', fontSize: 14 }}>Forgot your Password? <CustomText onPress={onForgotPasswordPressed} style={{ textDecorationLine: 'underline', fontSize: 14 }}>Reset it Here</CustomText></CustomText> */}

        <CustomText style={styles.copyright}>Oasys by Deloitte</CustomText>

        {/* just left it here for now */}
        {/* show error */}
        {/* {error && <div className="error">{error}</div>} */}

        {/* We Currently Do not have social sign in in Oasys so commented out */}
        {/* <SocialSignInButtons/> */}

        {/* <CustomButton 
          text="Sign Up" 
          onPress={onSignUpPressed} 
          type ="TERTIARY"
        /> */}
        {isLoading &&
          <View style={styles.loading}>
            <ActivityIndicator animating={true} size='large' color="#86BC25" />
          </View>
        }
      </View>
    </ScrollView>
  );
};

const makeStyles = (colors, colorScheme) => StyleSheet.create({
  areaview: {
    backgroundColor: '00F0F8FF'
  },
  root: {
    flex: 1,
    alignItems: "center",
    justifyContent: 'center',
    width: Platform.OS === 'web' ? (window.width < 500 ? window.width : window.width * 0.2) : window.width * 0.9,
    padding: 20,
    backgroundColor: colors.background,
  },
  title_hidden: {
    paddingTop: '10%',
    paddingBottom: '10%',
  },
  title: {
    fontSize: 24,
    paddingTop: '20%',
    paddingBottom: '10%',
    fontWeight: 'bold',
    color: colors.text_input,
    margin: 10,
  },
  tinyLogo: {
    width: 152,
    height: 172,
  },
  error: {
    color: colors.validation_error,
    alignSelf: 'center',
    fontSize: 14,
  },
  copyright: {
    marginVertical: '10%',
    paddingBottom: '12%',
    fontSize: 13,
    color: '#6e6e6e',
  }
});

export default SignUpScreen;